import React from "react";

interface TagStatusProps {
    value: string;
    /**
     * Text to show instead of `value`. `value` still picks the colours (the
     * switch below keys off the English status), so a caller with a
     * dictionary can pass the translated wording without losing the badge.
     */
    label?: string;
}

const TagStatus: React.FC<TagStatusProps> = ({ value, label }) => {
    const handleStatusTag = (val: string) => {
        // Based on the value, return different status tags with different background colors
        switch (val) {
            case "Draft":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#606060", backgroundColor: "#F9F9F9" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#606060" }}></div>
                        Draft
                    </div>
                );
            case "In progress":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#606060", backgroundColor: "#F9F9F9" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#606060" }}></div>
                        In progress
                    </div>
                );
            case "Sent":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#055BD4", backgroundColor: "#055BD41F" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#055BD4" }}></div>
                        Sent
                    </div>
                );
            case "Incomplete":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#673A92", backgroundColor: "#F7F5FF" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#673A92" }}></div>
                        Incomplete
                    </div>
                );
            case "Cancelled":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#B3080D", backgroundColor: "#F6E0E0" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#B3080D" }}></div>
                        Cancelled
                    </div>
                );
            case "Unpaid":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#B3080D", backgroundColor: "#F6E0E0" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#B3080D" }}></div>
                        Unpaid
                    </div>
                );
            case "Canceled":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#B3080D", backgroundColor: "#F6E0E0" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#B3080D" }}></div>
                        Canceled
                    </div>
                );
            case "Rejected":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#B3080D", backgroundColor: "#F6E0E0" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#B3080D" }}></div>
                        Rejected
                    </div>
                );
            case "Blocked":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#B3080D", backgroundColor: "#F6E0E0" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#B3080D" }}></div>
                        Blocked
                    </div>
                );
            case "Not Active":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#B3080D", backgroundColor: "#F6E0E0" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#B3080D" }}></div>
                        Not Active
                    </div>
                );
            case "InActive":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#B3080D", backgroundColor: "#F6E0E0" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#B3080D" }}></div>
                        InActive
                    </div>
                );
            case "Suspended":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#A65900", backgroundColor: "#FFECD7" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#A65900" }}></div>
                        Suspended
                    </div>
                );
            case "To be reviewed":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#A65900", backgroundColor: "#FFECD7" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#A65900" }}></div>
                        To be reviewed
                    </div>
                );
            case "Delayed":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#A65900", backgroundColor: "#FFECD7" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#A65900" }}></div>
                        Delayed
                    </div>
                );
            case "Overdue":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#A65900", backgroundColor: "#FFECD7" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#A65900" }}></div>
                        Overdue
                    </div>
                );
            case "Partially Paid":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#A65900", backgroundColor: "#FFECD7" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#A65900" }}></div>
                        Partially Paid
                    </div>
                );
            case "Pending Payment":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#A65900", backgroundColor: "#FFECD7" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#A65900" }}></div>
                        Pending Payment
                    </div>
                );
            case "Paid":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#2F933D", backgroundColor: "#EFF9F1" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#2F933D" }}></div>
                        Paid
                    </div>
                );
            case "Active":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#2F933D", backgroundColor: "#EFF9F1" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#2F933D" }}></div>
                        Active
                    </div>
                );
            case "Completed":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#2F933D", backgroundColor: "#EFF9F1" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#2F933D" }}></div>
                        Completed
                    </div>
                );
            // Reservation states (FIN-1110). Reuses the existing palette
            // (blue/green/orange/red) so the table-reservations module looks
            // visually consistent with the other tables that drive TagStatus.
            case "Pending":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#055BD4", backgroundColor: "#055BD41F" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#055BD4" }}></div>
                        Pending
                    </div>
                );
            case "Confirmed":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#2F933D", backgroundColor: "#EFF9F1" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#2F933D" }}></div>
                        Confirmed
                    </div>
                );
            case "Seated":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#A65900", backgroundColor: "#FFECD7" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#A65900" }}></div>
                        Seated
                    </div>
                );
            case "No Show":
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#B3080D", backgroundColor: "#F6E0E0" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#B3080D" }}></div>
                        No Show
                    </div>
                );
            default:
                return (
                    <div className="flex items-center gap-x-2" style={{ fontSize: '12px', borderRadius: "100px", height: "26px", padding: "5px 8px", color: "#606060", backgroundColor: "#F9F9F9" }}>
                        <div style={{ width: "6px", height: "6px", borderRadius: "100%", backgroundColor: "#606060" }}></div>
                        {value || "—"}
                    </div>
                );
        }
    };

    const tag = handleStatusTag(value);
    // Every branch renders [dot, text]; swap the text when a label is given.
    const translated =
        label && label !== value
            ? React.cloneElement(tag, {}, (tag.props as any).children[0], label)
            : tag;

    return <div className="w-fit">{translated}</div>;
};

export default TagStatus;
